import { FC } from 'react';
import { toMovesPairs } from '@whitesharx/starfall-frontend-core';
import { ProcessedAnalyzedMove } from '../../types';
import { moveNumberStyles } from './styles.css';
import { ColorfulSAN } from '../ColorfulSAN';

type Props = {
  moves?: ProcessedAnalyzedMove[];
  selected: ProcessedAnalyzedMove | null;
  onClick: (move: ProcessedAnalyzedMove) => void;
};

const PGN: FC<Props> = ({ moves, selected, onClick }) => {
  if (!moves?.length) {
    return null;
  }

  const formatted = toMovesPairs(moves);

  return (
    <>
      {formatted.map((move) => (
        <span key={move.number}>
          {' '}
          <span className={moveNumberStyles} onClick={() => onClick(move.white)}>
            {move.number}.
          </span>{' '}
          <ColorfulSAN
            value={move.white.san}
            grade={move.white.grade}
            selected={selected?.fen === move.white.fen}
            color="w"
            onClick={() => onClick(move.white)}
          />{' '}
          {move.black && (
            <ColorfulSAN
              value={move.black.san}
              grade={move.black.grade}
              selected={selected?.fen === move.black.fen}
              color="b"
              onClick={() => onClick(move.black!)}
            />
          )}
        </span>
      ))}
    </>
  );
};

export default PGN;
